/*!
/*!
 * Serialize all form data into a query string
 * (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param {Node} form The form to serialize
 * @return {String} The serialized form data
 */
const serialize = (form: HTMLFormElement) => {
  const serialized: string[] = [];

  for (let i = 0; i < form.elements.length; i += 1) {
    const field = form.elements[i] as HTMLInputElement | HTMLSelectElement;

    // eslint-disable-next-line no-continue
    if (!field.name || field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'button') continue;

    if (field instanceof HTMLSelectElement && field.type === 'select-multiple') {
      for (let n = 0; n < field.options.length; n += 1) {
        if (field.options[n].selected) {
          serialized.push(`${encodeURIComponent(field.name)}=${encodeURIComponent(field.options[n].value)}`);
        }
      }
    } else if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
      serialized.push(`${encodeURIComponent(field.name)}=${encodeURIComponent(field.value)}`);
    }
  }

  return serialized.join('&');
};

function refresh(ms: number) {
  setTimeout(() => {
    window.location.reload();
  }, ms);
}

function addWindowObject() {
  const form = document.querySelector<HTMLFormElement>('#elc-cookie-consent-form');
  if (form && form.dataset.show) {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', form.dataset.show);
    xhr.send();

    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4) {
        if (xhr.status !== 200) {
          window.ccc = {};
        } else if (xhr.response === 'null') {
          window.ccc = {};
        } else {
          window.ccc = JSON.parse(xhr.response);
          if (window.ccc && !form.classList.contains('gtm-fired')) {
            form.classList.add('gtm-fired');
            const consentList = ['marketing', 'necessary', 'statistics'];
            if (window.DATALAYER) {
              Object.keys(window.ccc).forEach((key) => {
                consentList.forEach((consentType) => {
                  if (key.includes(consentType) && window.ccc[key]) {
                    window.DATALAYER.push({ event: `cookieconsent_${consentType}` });
                  }
                });
              });
            }
          }
        }
      }
    };
  }
}

function submitData(form: HTMLFormElement, submitAll: boolean) {
  let data = serialize(form);
  if (!document.getElementById('elc-cookie-consent-container')?.classList.contains('on-page')) {
    document.getElementById('elc-cookie-consent')?.classList.toggle('elc-hidden');
    document.getElementById('elc-cookie-consent-container')?.classList.toggle('elc-hidden');
    const cookieTab = document.getElementById('elc-cookie-tab');
    cookieTab?.classList.toggle('elc-hidden');
  }

  const xhr = new XMLHttpRequest();
  xhr.open('POST', form.dataset.url || '');
  xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
  if (submitAll) {
    data += '&acceptAll=true';
  }
  xhr.send(data);

  xhr.onreadystatechange = () => {
    if (xhr.readyState === 4) {
      addWindowObject();
      if (xhr.status === 200 && form.dataset.refresh === 'true' && form.dataset.refreshtime) {
        refresh(parseInt(form.dataset.refreshtime, 10));
      }
    }
  };
}

function submitConsent(event: Event) {
  event.preventDefault();

  const form = document.querySelector<HTMLFormElement>('#elc-cookie-consent-form');
  if (form) {
    submitData(form, false);
  }
}

function submitAllConsent(event: Event) {
  event.preventDefault();

  const form = document.querySelector<HTMLFormElement>('#elc-cookie-consent-form');
  if (form) {
    for (let i = 0; i < form.elements.length; i += 1) {
      const element = form.elements[i] as HTMLInputElement;
      if (element.type === 'checkbox' && !element.checked) {
        element.checked = true;
      }
    }
    submitData(form, true);
  }
}

function submitDeclineAllConsent(event: Event) {
  event.preventDefault();

  const form = document.querySelector<HTMLFormElement>('#elc-cookie-consent-form');
  if (form) {
    for (let i = 0; i < form.elements.length; i += 1) {
      const element = form.elements[i] as HTMLInputElement;
      if (element.type === 'checkbox' && element.checked && !element.disabled) {
        element.checked = false;
      }
    }
    submitData(form, false);
  }
}

function toggleExpand(event: Event) {
  event.preventDefault();
  document.getElementById('elc-cookie-consent')?.classList.toggle('elc-fullwidth');
  document.getElementById('elc-cookie-consent')?.classList.toggle('elc-small');
}

function toggleTab(event: Event) {
  event.preventDefault();
  document.getElementById('elc-cookie-consent')?.classList.toggle('elc-hidden');
  document.getElementById('elc-cookie-consent-container')?.classList.toggle('elc-hidden');
  document.getElementById('elc-cookie-tab')?.classList.toggle('elc-hidden');

  const consentElement = document.getElementById('elc-cookie-consent');
  consentElement?.classList.add('elc-fullwidth');
  consentElement?.classList.remove('elc-small');
}

document.addEventListener('afterBlitzInject', () => {
  const detailLink = document.getElementById('elc-detail-link');
  if (detailLink) {
    detailLink.addEventListener('click', toggleExpand);
  }

  const hideDetailLink = document.getElementById('elc-hide-detail-link');
  if (hideDetailLink) {
    hideDetailLink.addEventListener('click', toggleExpand);
  }

  const saveLink = document.getElementById('elc-save-link');
  if (saveLink) {
    saveLink.addEventListener('click', submitConsent);
  }

  const acceptLink = document.getElementById('elc-accept-link');
  if (acceptLink) {
    acceptLink.addEventListener('click', submitConsent);
  }

  const acceptAllLink = document.getElementById('elc-accept-all-link');
  if (acceptAllLink) {
    acceptAllLink.addEventListener('click', submitAllConsent);
  }

  const declineAllLink = document.getElementById('elc-decline-all-link');
  if (declineAllLink) {
    declineAllLink.addEventListener('click', submitDeclineAllConsent);
  }

  const tabLink = document.getElementById('elc-tab-link');
  if (tabLink) {
    tabLink.addEventListener('click', toggleTab);
  }

  addWindowObject();
});

export {};
